var app = angular.module("nms.dynamicDevice");

app.directive("unsignedInteger",
    function() {
        return {
            restrict: "E",
            templateUrl: "templates/features/dynamic-device/domain/yang/leaf/types/numbers/unsigned-integer.html"
        };
    }
);
